import React from "react";
import { setInfoKey } from '../../api/information-collection/actions'
import { setKey } from '../../api/insurance-takers/actions'
import { updateContract, updateContracts } from '../../api/contracts/actions'
import { SvgTrashIcon, SvgUploadImageIcon } from "../svg";
import moment from 'moment'


class FileUploader extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            files: [],
            uploadedFiles: [],
            isUploading: false,
        }
        this.updateContract = this.updateContract.bind(this)
    }

    componentDidMount() {
        var $form = $('.box');

        if (this.isAdvancedUpload()) {
            $form.addClass('has-advanced-upload');
        }
    }

    addBase64FilesToInfo(newFiles) {
        let allBase64Files = [];

        if (newFiles) {
            let allJpgFiles = newFiles.filter(item => item.errorMsg !== "");
            allJpgFiles.map((newFile) => {
                allBase64Files.push({ name: newFile.name, data: newFile.base64, type: newFile.file.type })
            })
        } else {
            let allJpgFiles = this.state.files.filter(item => item.errorMsg !== "");
            allJpgFiles.map((file) => {
                allBase64Files.push({ name: file.name, data: file.base64, type: file.file.type })
            })
        }
        this.props.dispatch(setKey({ key: 'images', value: allBase64Files }, this.props.insuranceTaker))
    }

    onDone(files) {
        this.setState({
            files: [
                ...this.state.files,
                ...files
            ]
        })
        { !this.props.updateContract && this.addBase64FilesToInfo() }
    }

    handleChange(e) {
        let files = e.target.files;
        var allFiles = [];
        for (var i = 0; i < files.length; i++) {

            let file = files[i];
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                let fileInfo = {
                    name: file.name,
                    type: file.name.split('.').pop(),
                    size: Math.round(file.size / 1000) + ' kB',
                    base64: reader.result,
                    file: file,
                };
            
                if (Math.round(file.size / 1000) > 15000){
                    return (
                        alert("Ekki var hægt að hlaða upp skjali (skjal má að hámarki vera 15MB).")
                    )
                }

                if (['jpg', 'png', 'heic', 'pdf', 'jpeg', 'JPG', 'PNG', 'HEIC', 'PDF', 'JPEG'].includes(file.name.split('.').pop())) {
                    allFiles.push(fileInfo);
                }

                if (allFiles.length == files.length) {
                    this.onDone(allFiles)
                } else {
                    return (
                        alert("Þú hefur bætt við skjali á " + file.name.split('.').pop() + " formi.\n Skjalið þarf að vera á jpg, jpeg, png, pdf eða heic formi.")
                    )
                }
            }
        }
    }

    isAdvancedUpload() {
        var div = document.createElement('div');
        return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window;
    };

    removeImage(file) {
        let newFiles = []
        this.state.files.map((f) => {
            if (f.base64 !== file.base64) {
                newFiles.push(f)
            }
            return newFiles
        })
        this.setState({
            files: newFiles
        })
        { !this.props.updateContract && this.addBase64FilesToInfo(newFiles) }
    }

    renderAddedFiles() {
        if (this.state.files.length > 0) {

            let allFiles = this.state.files.map((file) => {
                
                return (
                    <div key={file.base64 || file.name} className="photo-container">
                        <div className="file-uploader photo">
                            { file.type !== "pdf" && file.type !== "heic" && <img src={file.base64} /> }
                        </div>
                        <div className="photo-text">
                            <div className="erase-btn" onClick={this.removeImage.bind(this, file)}>
                                <span>Eyða</span>
                                <SvgTrashIcon />
                            </div>
                            <div className="file-name">{file.name}</div>
                        </div>
                    </div>
                )
                // if (file.errorMsg === '') {
                // }
            })
            return allFiles;
        }
    }

    renderUploadedFiles(){
        if (this.state.uploadedFiles.length > 0) {

            let allFiles = this.state.uploadedFiles.map((file) => {
                
                return (
                    <div key={(file.file && file.file.name) || file.name} className="success-photo-container">
                        <div className="photo-text">
                            <div>{file.file.name} hlaðið upp sem {file.name}</div>
                        </div>
                    </div>
                )
            })
        return <div className="uploaded-photo-container"><div className="uploaded-title">Eftirfarandi skrám hefur verið hlaðið upp:</div>{allFiles}</div>;
        }
    }

    updateContract() {
        this.setState({
            isUploading: true
        })
        let allJpgFiles = this.state.files.filter(item => item.errorMsg !== "").map(f => {
            let fileObj = {...f}
            let fileType = fileObj.name.split('.').pop()
            let fileName = fileObj.name
            if (!this.props.useOriginalFilename) {
                fileName = `skilriki_${moment.utc().format("D.M.YYYY")}.${fileType}`
            }
            fileObj.name = fileName
            return fileObj
        })
        if(this.props.multipleIds){
            Promise.resolve(
                this.props.dispatch(updateContracts(this.props.multipleIds, allJpgFiles))
            )
            .then(() => {
                if (this.props.contracts.photoUploadStatus === 200) {
                    let allUploadedFiles = this.state.uploadedFiles;
                    allUploadedFiles = allUploadedFiles.concat(allJpgFiles)
                    this.setState({
                        files: [],
                        uploadedFiles: allUploadedFiles,
                        isUploading: false
                    })
                    if (this.props.toggleAddPhotoView) {
                        this.props.toggleAddPhotoView();
                    }
                } else {
                    this.setState({
                        photoUploadError: 'Ekki var hægt að hlaða upp skránum',
                        isUploading: false
                    })
                }
            }, 500)
        } else {
            Promise.resolve(
                this.props.dispatch(updateContract(this.props.contractId, allJpgFiles))
            )
                .then(() => {
                    if (this.props.contracts.photoUploadStatus === 200) {
                        let allUploadedFiles = this.state.uploadedFiles;
                        allUploadedFiles = allUploadedFiles.concat(allJpgFiles)
                        this.setState({
                            files: [],
                            uploadedFiles: allUploadedFiles,
                            isUploading: false
                        })
                        if (this.props.toggleAddPhotoView) {
                            this.props.toggleAddPhotoView();
                        }
                    } else {
                        this.setState({
                            photoUploadError: 'Ekki var hægt að hlaða upp skránum',
                            isUploading: false
                        })
                    }
                }, 500)
        }
    }
    render() {
        return (<>
            <div className="add-photo-container">
                <div className="photo-added-container">
                    <form className="file-uploader box" method="post" action="" encType="multipart/form-data" >
                        <fieldset disabled={this.props.disabled} >
                            <div className="box__input">
                                <input
                                    className="box__file"
                                    type="file"
                                    onChange={this.handleChange.bind(this)}
                                    multiple={this.props.multiple} />
                                <div className="box__dragndrop">
                                    <SvgUploadImageIcon />
                                    <label htmlFor="file"><strong>Smelltu hér til að sækja skjal</strong><span > eða dragðu það hingað</span>.</label>
                                </div>
                            </div>
                        </fieldset>
                    </form>
                    <div className="photos-container">
                        {this.renderAddedFiles()}
                        {this.props.updateContract && this.state.files.length > 0 &&
                            <div className="button-container">
                                <button className="btn btn-primary" onClick={this.updateContract}>{this.state.isUploading ? 'Hleður upp...' : 'Vista'}</button>
                            </div>
                        }
                        {this.renderUploadedFiles()}
                    </div>
                </div>

                {this.props.updateContract && this.state.photoUploadError && <div>{this.state.photoUploadError}</div>}
            </div>
        </>
        );
    }
}

FileUploader.defaultProps = {
    useOriginalFilename: false
}

export default FileUploader